import { ICart, CartSchema } from '@shared/types.ts';
import { fetcher } from '@shared/fetcher';

export async function fetchCart(url: string): Promise<ICart | undefined> {
  const res = await fetcher.get<{ data: ICart }>(url).catch(() => null);
  if (!res?.data) return undefined;
  if (CartSchema.isValidSync(res?.data.data)) {
    return res?.data.data;
  }
  return undefined;
}

export async function updateProduct(
  url: string,
  { arg }: { arg: { productId: number; quantity: number } }
) {
  return fetcher.post<{ message: string }>(url, {
    product_id: arg.productId,
    quantity: arg.quantity,
  });
}

export async function updateProducts(
  url: string,
  { arg }: { arg: { productId: number; quantity: number }[] }
) {
  return fetcher.post<{ message: string }>(url, {
    products: arg.map((item) => ({
      product_id: item.productId,
      quantity: item.quantity,
    })),
  });
}

export async function removeCart(url: string) {
  return fetcher.delete(url);
}

export async function removeCartProduct(
  url: string,
  { arg }: { arg: { cartProductId: number } }
) {
  return fetcher.delete(`${url}/${arg.cartProductId}`);
}
